import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

//Fake backend
import fakeBackend from "./helpers/AuthType/fakeBackend";
import AppRoute from "./routes/route";
import { fetchVendorActionLogDetails } from "./custom/Utils/vendorLogsUtils";
import IdleService from "./services/IdleService/useIdleService";

//Firebase helper
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
// 	apiKey: process.env.REACT_APP_APIKEY,
// 	authDomain: process.env.REACT_APP_AUTHDOMAIN,
// 	databaseURL: process.env.REACT_APP_DATABASEURL,
// 	projectId: process.env.REACT_APP_PROJECTID,
// 	storageBucket: process.env.REACT_APP_STORAGEBUCKET,
// 	messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
// 	appId: process.env.REACT_APP_APPID,
// 	measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getLayout = this.getLayout.bind(this);
  }

  /**
   * Returns the layout
   */
  getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (this.props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };
   getTokenExpiration = async (token) => {
    try {
        const payload = JSON.parse(atob(token.split(".")[1])); // Decode JWT
        return payload.exp ? payload.exp * 1000 : null; // Convert to milliseconds
    } catch (error) {
        console.error("Invalid token", error);
        return null;
    }
};
handleLogout = async () => { 
    try {
        await fetchVendorActionLogDetails('Logout','Idle for 30 min'); // Log the logout action
    } catch (error) {
        console.error("Error logging logout action:", error);
    }

    localStorage.clear(); // Clear session
    window.location.href = "/logout"; // Redirect to logout
};
handleLogoutOnTokenExpire = async () => {
    console.log("Logging out user...");
    
    try {
        await fetchVendorActionLogDetails('Logout','Token Expired'); // Log the logout action
    } catch (error) {
        console.error("Error logging logout action:", error);
    }

    localStorage.clear(); // Clear session
    window.location.href = "/logout"; // Redirect to logout
};
checkTokenExpiration = async () => {
    const authUser = localStorage.getItem('authUser'); // Get authUser from localStorage
    if (!authUser) return; // No authUser, skip check

    try {
        const parsedUser = JSON.parse(authUser); // Parse JSON
        const token = parsedUser.accessToken; // Get accessToken

        if (!token) return; // No token, skip check
        const expirationTime = await this.getTokenExpiration(token);
        
        if (!expirationTime) return; // Invalid token, skip

        const currentTime = Date.now();
        if (currentTime >= expirationTime) {
            this.handleLogoutOnTokenExpire(); // Call logout function
        } else {
            // Schedule logout check right before the token expires
            setTimeout(
                this.handleLogoutOnTokenExpire,
                expirationTime - currentTime
            );
        }
    } catch (error) {
        console.error('Error parsing authUser:', error);
    }
};
 componentDidMount() {
    console.log('Component Mounted!');
    this.checkTokenExpiration(); // Check token expiration when the app loads
  }
  componentDidUpdate(prevProps, prevState) {
    const authUser = localStorage.getItem('authUser');
    if (authUser && authUser !== prevState.authUser) {
        this.checkTokenExpiration(); // Run when authUser is updated
    }
}
  render() {
    const Layout = this.getLayout();

    return (
      <React.Fragment>
       <IdleService logoutCallback={this.handleLogout}/>
        {/* <Router>
					<Routes>
						{publicRoutes.map((route, idx) => (
							<AppRoute
								path={route.path}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								isAuthProtected={false}
							/>
						))}

						{authProtectedRoutes.map((route, idx) => (
							<AppRoute
								path={route.path}
								layout={Layout}
								component={route.component}
								key={idx}
								isAuthProtected={true}
							/>
						))}
					</Routes>
				</Router> */}

        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <AppRoute>
                  <Layout>{route.component}</Layout>
                </AppRoute>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Routes>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
